export default __webpack_public_path__ + "bookmark-black-shape.png";